export const PAGE_NAME = {
  inbox: 'inbox',
  leadManagement: 'leadManagement',
  leads: 'leads',
} as const;
